import { FormattedMessage } from "react-intl";
import CreateTrainingTypeIcon from "../../../../components/Common/SvgIcons/ManageIcons/CreateTrainingTypeIcon";
import DeleteIcon from "../../../../components/Common/SvgIcons/TableIcons/DeleteIcon";
import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import Tooltip from "../../../../components/Common/ToolTip/Tooltip";
import { tableColumnTypes } from "../../../tableColumnTypes";
import { admin } from "../admin";
import { organizationSettings } from "./organizationSettings";

export const setUpDomainName = {
  label: "Create Domain Name",
  path: (tenantName) =>
    `${admin.path(tenantName)}/organizationSettings/setUpDomainName`,
  icon: CreateTrainingTypeIcon,
  searchPlaceHolder: "Search Domain Name",
  navLinks: (navigate, tenantName) => [
    {
      key: 1,
      label: admin.name,
      path: admin.path(tenantName),
      onClick: () => navigate(admin.path(tenantName)),
    },
    {
      key: 2,
      label: organizationSettings.name,
      path: `${organizationSettings.path(tenantName)}`,
      onClick: () => navigate(organizationSettings.path(tenantName)),
    },
    {
      key: 3,
      label: setUpDomainName.label,
      path: `${setUpDomainName.path(tenantName)}`,
      onClick: () => navigate(`${setUpDomainName.path(tenantName)}`),
    },
  ],
  columns: (handleDelete, handleEdit) => [
    {
      ID: 1,
      name: <FormattedMessage id="DOMAIN_NAME" />,
      fieldName: "Name",
      value: (row) => row.Name,
      sort: true,
      type: tableColumnTypes.STRING,
    },
    {
      ID: 2,
      name: <FormattedMessage id="USERMANAGE_SEARCHACTION" /> ,
      fieldName: "",
      value: (row) => (
        <>
          <Tooltip content={<FormattedMessage id="DELETE_TXT" />} direction={"bottom"} show={row.CanDelete}>
            <span
              onClick={() => handleDelete(row.Id, row.Name)}
              // style={{ visibility: row.CanDelete ? "visible" : "hidden" }}
            >
              <DeleteIcon />
            </span>
          </Tooltip>
          <Tooltip content={<FormattedMessage id="MYCLASS_EDIT" />} direction={"bottom"}>
            <span onClick={() => handleEdit(row.Id, row.Name)}>
              <EditIcon />
            </span>
          </Tooltip>
        </>
      ),
      sort: false,
    },
  ],
};
